'use strict';

var React = require('react');
var PLWidgetController = require('./PLWidgetController-f604e4ab.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const WidgetController = ({ cards }) => {
    const cardsLength = cards.length;
    return (React__default['default'].createElement(React__default['default'].Fragment, null, cards.map((widget, index) => {
        return (React__default['default'].createElement(PLWidgetController.WidgetRenderer, { widget: widget, key: index, position: index, isLastCard: cardsLength === index + 1 }));
    })));
};
var WidgetController$1 = React__default['default'].memo(WidgetController);

exports.WidgetController = WidgetController$1;
//# sourceMappingURL=WidgetController-3fcf9283.js.map
